export default "__VITE_ASSET__6e46ef8f__"